'use memo';

import { AgxSpacer, AgxTypography, Icon_CheckmarkCircleOutline } from '@urbanx/agx.ui-components2';
import './BlankContractProgress.scss';
import { BlankContractProgressModel } from '@urbanx/agx.campaigns.client';
import { renderProgress } from './BlankContractProgress.helpers';
import { CircularProgressIndicator } from './CircularProgressIndicator';

interface BlankContractProgressProps {
  blankContractProgress: BlankContractProgressModel;
}

const BlankContractProgress = ({ blankContractProgress }: BlankContractProgressProps) => {
  const completedSteps = [
    blankContractProgress.titleSearchComplete && blankContractProgress.showTitleSearchProgress,
    blankContractProgress.surveyPlanComplete && blankContractProgress.showSurveyPlanProgress,
    blankContractProgress.sellersDisclosureComplete &&
      blankContractProgress.showSellersDisclosureProgress,
    blankContractProgress.poolSafetyComplete && blankContractProgress.showPoolSafetyProgress,
    blankContractProgress.tenancyInformationComplete &&
      blankContractProgress.showTenancyInformationProgress,
    blankContractProgress.bodyCorporateComplete && blankContractProgress.showBodyCorporateProgress,
    blankContractProgress.communityManagementStatementComplete &&
      blankContractProgress.showCommunityManagementStatementProgress,
    blankContractProgress.ownerBuilderComplete && blankContractProgress.showOwnerBuilderProgress,
    blankContractProgress.finalisingContract,
  ].filter(Boolean).length;

  const totalSteps = [
    blankContractProgress.showTitleSearchProgress,
    blankContractProgress.showSurveyPlanProgress,
    blankContractProgress.showSellersDisclosureProgress,
    blankContractProgress.showPoolSafetyProgress,
    blankContractProgress.showTenancyInformationProgress,
    blankContractProgress.showBodyCorporateProgress,
    blankContractProgress.showCommunityManagementStatementProgress,
    blankContractProgress.showOwnerBuilderProgress,
    true,
  ].filter(Boolean).length;

  return (
    <AgxSpacer fill contentAlignment="center" gap="md">
      <AgxSpacer fill contentAlignment="center" padding="md" gap="md">
        {blankContractProgress.finalisingContract ? (
          <>
            <Icon_CheckmarkCircleOutline
              color="var(--fg-success, var(--ui-success))"
              width={44}
              height={45}
            />
            <AgxTypography id="age-blank-contract-ready" type="body" size="medium">
              Blank Contract is ready
            </AgxTypography>
          </>
        ) : (
          <>
            <CircularProgressIndicator
              currentSteps={completedSteps}
              totalSteps={totalSteps}
              width={60}
              height={60}
            />
            <AgxTypography id="balnk-contract-in-progress" type="body" size="medium">
              Blank Contract preparation in progress
            </AgxTypography>
          </>
        )}
      </AgxSpacer>

      {!blankContractProgress.finalisingContract && (
        <AgxSpacer fill direction="vertical" className="blankContractPreparationBody">
          {blankContractProgress.showTitleSearchProgress &&
            renderProgress('Title Search', blankContractProgress.titleSearchComplete ?? false)}
          {blankContractProgress.showSurveyPlanProgress &&
            renderProgress('Survey Plan', blankContractProgress.surveyPlanComplete ?? false)}
          {blankContractProgress.showSellersDisclosureProgress &&
            renderProgress(
              'Sellers Disclosure',
              blankContractProgress.sellersDisclosureComplete ?? false
            )}
          {blankContractProgress.showPoolSafetyProgress &&
            renderProgress('Pool Safety', blankContractProgress.poolSafetyComplete ?? false)}
          {blankContractProgress.showTenancyInformationProgress &&
            renderProgress(
              'Tenancy Information',
              blankContractProgress.tenancyInformationComplete ?? false
            )}
          {blankContractProgress.showBodyCorporateProgress &&
            renderProgress(
              'Body Corporate Certificate',
              blankContractProgress.bodyCorporateComplete ?? false
            )}
          {blankContractProgress.showCommunityManagementStatementProgress &&
            renderProgress(
              'Community Management Statement',
              blankContractProgress.communityManagementStatementComplete ?? false
            )}
          {blankContractProgress.showOwnerBuilderProgress &&
            renderProgress(
              'Owner Builder Declaration',
              blankContractProgress.ownerBuilderComplete ?? false
            )}
          {renderProgress('Finalising Contract', blankContractProgress.finalisingContract ?? false)}
        </AgxSpacer>
      )}
    </AgxSpacer>
  );
};

export default BlankContractProgress;
